<template>
  <div class="page-card pwd-page">
    <a-form
      v-model:model="pwdForm"
      layout="vertical"
      class="pwd-form"
      @finish="submit"
    >
      <a-form-item label="旧密码" name="OldPwd">
        <a-input-password v-model:value="pwdForm.OldPwd" placeholder="请输入旧密码" allow-clear />
      </a-form-item>
      <!-- <div class="forget-pwd">忘记密码? <a>重置</a></div> -->

      <a-form-item label="新密码" name="NewPwd">
        <a-input-password v-model:value="pwdForm.NewPwd" placeholder="请输入新密码" allow-clear />
        <div class="pwd-rule">密码由数字、英文字母或特殊符号组成，至少包含2种类型，不少于8个字符</div>
      </a-form-item>

      <a-form-item label="确认密码" name="confirmPassword">
        <a-input-password v-model:value="pwdForm.confirmPassword" placeholder="请输入新密码" allow-clear />
      </a-form-item>

      <a-form-item>
        <a-button type="primary" html-type="submit">保存</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script setup>
import { defineEmits, reactive } from 'vue'
import { message } from 'ant-design-vue'
import { changePassword } from '../../api/userapi'
const emit = defineEmits(['modify-pwd'])

const pwdForm = reactive({
  OldPwd: '',
  NewPwd: '',
  confirmPassword: ''
})

// 密码强度校验：至少包含数字、字母、特殊符号中的2种，不少于8个字符
const validatePwd = (pwd) => {
  if (pwd.length < 8) return '密码长度不能少于8个字符'
  let types = 0
  if (/[0-9]/.test(pwd)) types++
  if (/[a-zA-Z]/.test(pwd)) types++
  if (/[^0-9a-zA-Z]/.test(pwd)) types++
  if (types < 2) return '密码需由数字、英文字母或特殊符号组成，至少包含2种类型'
  return ''
}

// 提交密码修改
const submit = async () => {
  console.log(pwdForm)
  // 前端验证
  if (!pwdForm.OldPwd) {
    message.error('请输入原密码')
    return
  }
  if (!pwdForm.NewPwd) {
    message.error('请输入新密码')
    return
  }
  const pwdErr = validatePwd(pwdForm.NewPwd)
  if (pwdErr) {
    message.error(pwdErr)
    return
  }
  if (pwdForm.NewPwd !== pwdForm.confirmPassword) {
    message.error('两次输入的密码不一致')
    return
  }

  try {
    const data = {
      OldPwd: pwdForm.OldPwd,
      NewPwd: pwdForm.NewPwd
    }
    await changePassword(data)
    message.success('密码修改成功')
    emit('modify-pwd')
    pwdForm.OldPwd = ''
    pwdForm.NewPwd = ''
    pwdForm.confirmPassword = ''
  } catch (error) {
    console.error('修改密码失败:', error)
    message.error('修改密码失败: ' + (error.message || '未知错误'))
  }
}
</script>

<style scoped lang="less">
.page-card {
  background: #F7F8FA;
  border-radius: 0 0 12px;
  padding: 28px;
  min-height: 820px;
  border: 34px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
//   margin: 0 auto;
//   max-width: 600px;
}
.pwd-form {
    background-color: #fff;
  min-width: 820px;
//   min-height: 420px;
  padding: 24px;
}
.forget-pwd {
  font-size: 13px;
  color: #8c8c8c;
  margin: -8px 0 16px;
  a {
    color: #1677ff;
  }
}
.pwd-rule {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 4px;
}
</style>